module.exports = __webpack_public_path__ + "img/planning.0196321f.svg";